// extracted by mini-css-extract-plugin
module.exports = {"paragraphClass":"Paragraph_paragraphClass__3YNp2"};